export function blogImageWrap(){
    $(".blog-details-container .content img").each(function (i, item) {
        let alt = $(item).attr("alt");
        let figure = $("<figure></figure>");
        let figcaption = $("<figcaption>" + alt + "</figcaption>");
        $(item).unwrap().wrap(figure);
        $(item).parent().append(figcaption);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/blog-image-wrap.js